// Centralized query key constants used across the app

// Global menu badges (sidenav) query key
export const MENU_BADGES_QUERY_KEY = 'menu-badges';

// Per-queue notifications/badges query key (scoped by WorkflowScopes)
export const QUEUE_NOTIFICATIONS_QUERY_KEY = 'queue-notifications';

// Provider referrals list query key
export const PROVIDER_REFERRALS_LIST_QUERY_KEY = 'provider-referrals-list';
